<div class="page-header full">
    <div class="container no-wrap justify-content-between pt-3 pb-4 pt-lg-4 pl-0">
        <h2 class="page-header__title large">
            <strong>Dashboard</strong>
        </h2>
    </div>
</div>

<div class="dashboard">
    <div class="container">
        <section class="dashboard_top row w-full justify-content-md-end ">
            <div class="col-sm-6 col-lg-3">
                <div class="input-material select d-flex">
                    <ng-multiselect-dropdown
                            [settings]="dropSettings"
                            [(ngModel)]="selectedSectors"
                            [data]="listSectors"
                            [placeholder]="'sectors' | translate">
                    </ng-multiselect-dropdown>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3">
                <div class="input-material select d-flex">
                    <ng-multiselect-dropdown
                            [settings]="dropSettings"
                            [(ngModel)]="selectedUnities"
                            [data]="listUnities"
                            [placeholder]="'unidade' | translate">
                    </ng-multiselect-dropdown>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3">
                <div class="input-material">
                    <input id="date" class="form-control picker-period" type="text" required/>
                    <label for="date">
                        <span>{{ 'periodo'|translate }}</span>
                        <svg-icon class="right" src="assets/svg/calendar.svg"></svg-icon>
                    </label>
                </div>
            </div>
            <div class="col-sm-4 col-lg-3">
                <a class="btn btn-primary w-full btn-lg text-white"
                   (click)="getSearchRoutes()">{{ 'buscar'|translate }}</a>
            </div>
        </section>
        <section class="row wrap justify-content-between mt-4">
            <article class="col-12 col-md-6 col-xl d-flex flex-column">
                <div class="card-primary mb-0 h-100">
                    <div class="card-primary-box">
                        <div class="card-primary-header">
                            <div class="row align-items-center d-flex ml-1">
                                <svg-icon src="assets/svg/declaracaoexame-gray.svg"></svg-icon>
                                <small class="ml-4" style="color: #53565a">Atestado médico</small>
                            </div>
                        </div>
                        <hr class="col-12">
                        <div class="card-primary-body text-center py-2 justify-content-center align-items-center d-flex">
                            <h2 class="text-primary mb-0 pb-0">
                                <strong>{{ modelMedicalCertificateTotalsDto?.certificate || 0 }}</strong></h2>
                        </div>
                    </div>
                </div>
            </article>
            <article class="col-12 col-md-6 col-xl d-flex flex-column">
                <div class="card-primary mb-0 h-100">
                    <div class="card-primary-box">
                        <div class="card-primary-header">
                            <div class="row align-items-center d-flex ml-1">
                                <svg-icon src="assets/svg/camera-gray.svg"></svg-icon>
                                <small class="ml-4" style="color: #53565a">Declaração <br>de consultas e exames</small>
                            </div>
                            <hr>
                        </div>
                        <div class="card-primary-body text-center py-2 justify-content-center align-items-center d-flex">
                            <h2 class="text-primary">
                                <strong>{{ modelMedicalCertificateTotalsDto?.consult || 0 }}</strong></h2>
                        </div>
                    </div>
                </div>
            </article>
            <article class="col-12 col-md-6 col-xl d-flex flex-column">
                <div class="card-primary mb-0 h-100">
                    <div class="card-primary-box">
                        <div class="card-primary-header">
                            <div class="row align-items-center d-flex ml-1">
                                <svg-icon src="assets/svg/declaracaoacompanhante-gray.svg"></svg-icon>
                                <small class="ml-4" style="color: #53565a">Declaração <br>de acompanhante</small>
                            </div>
                            <hr>
                        </div>
                        <div class="card-primary-body text-center py-2 justify-content-center align-items-center d-flex">
                            <h2 class="text-primary">
                                <strong>{{ modelMedicalCertificateTotalsDto?.escort || 0 }}</strong></h2>
                        </div>
                    </div>
                </div>
            </article>
            <article class="col-12 col-md-6 col-xl d-flex flex-column">
                <div class="card-primary mb-0 h-100">
                    <div class="card-primary-box">
                        <div class="card-primary-header">
                            <div class="row align-items-center d-flex ml-1">
                                <svg-icon src="assets/svg/maternidade-gray.svg"></svg-icon>
                                <small class="ml-4" style="color: #53565a">Licença Maternidade</small>
                            </div>
                            <hr>
                        </div>
                        <div class="card-primary-body text-center py-2 justify-content-center align-items-center d-flex">
                            <h2 class="text-primary">
                                <strong>{{ modelMedicalCertificateTotalsDto?.maternity || 0 }}</strong></h2>
                        </div>
                    </div>
                </div>
            </article>
            <article class="col-12 col-md-6 col-xl d-flex flex-column">
                <div class="card-primary mb-0 h-100">
                    <div class="card-primary-box">
                        <div class="card-primary-header">
                            <div class="row align-items-center d-flex ml-1">
                                <svg-icon src="assets/svg/blood-gray.svg"></svg-icon>
                                <small class="ml-4" style="color: #53565a">Doação de Sangue</small>
                            </div>
                            <hr>
                        </div>
                        <div class="card-primary-body text-center py-2 justify-content-center align-items-center">
                            <h2 class="text-primary">
                                <strong>{{ modelMedicalCertificateTotalsDto?.donation || 0 }}</strong></h2>
                        </div>
                    </div>
                </div>
            </article>
        </section>
        <section class="row pt-5">
            <article class="col-12">
                <div class="card-primary">
                    <div class="card-primary-box">
                        <div class="card-primary-header">
                            <p class="card-primary-header-title">Atestados Médicos <strong>| Mês</strong></p>
                            <hr>
                        </div>
                        <div class="card-primary-body">
                            <div class="card-primary-body-graph d-flex justify-content-center align-items-center">
                                <google-chart
                                        [type]="columnChart.type"
                                        [data]="columnChart.data"
                                        [columns]="columnChart.columnNames"
                                        [options]="columnChart.options"
                                        [width]="columnChart.width"
                                        [height]="columnChart.height">
                                </google-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </article>

            <article class="col-12 col-lg-6">
                <div class="card-primary">
                    <div class="card-primary-box">
                        <div class="card-primary-header">
                            <p class="card-primary-header-title">Top 10 <strong>CID</strong></p>
                            <hr>
                        </div>
                        <div class="card-primary-body">
                            <div class="card-primary-body-graph d-flex justify-content-center align-items-center">
                                <google-chart
                                        [type]="donutChart.type"
                                        [data]="donutChart.data"
                                        [columns]="donutChart.columnNames"
                                        [options]="donutChart.options"
                                        [width]="donutChart.width"
                                        [height]="donutChart.height">
                                </google-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </article>

            <article class="col-12 col-lg-6">
                <div class="card-primary">
                    <div class="card-primary-box">
                        <div class="card-primary-header">
                            <p class="card-primary-header-title">Atestados Médicos <strong>| Dias</strong></p>
                            <hr>
                        </div>
                        <div class="card-primary-body">
                            <div class="card-primary-body-graph d-flex justify-content-center align-items-center">
                                <google-chart
                                        [type]="lineChart.type"
                                        [data]="lineChart.data"
                                        [columns]="lineChart.columnNames"
                                        [options]="lineChart.options"
                                        [width]="lineChart.width"
                                        [height]="lineChart.height">
                                </google-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </section>
    </div>
</div>




